import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { CourseInfo } from '../types/apis/contentsListApi';
import { PAGE_PATH_NAME } from '../utils/const';

// 画面遷移時に渡す値
export type SelectTrainingPageState = {
  trainingId: number;
  contents: CourseInfo[];
};

// 本画面の返り値
export type UseSelectTrainingValue = {
  topicNumber: string;
  onClickTopicButton: (topic: string) => void;
  onClickTrainingButton: (trainingId: number, contents: CourseInfo[]) => void;
  onClickContinueButton: (trainingId: number, contents: CourseInfo[]) => void;
};

const useSelectTraining = (): UseSelectTrainingValue => {
  // state
  const [topicNumber, setTopicNumber] = useState<string>('');

  const history = useHistory();

  // トピック押下時処理
  const onClickTopicButton = (topic: string) => {
    if (topic === topicNumber) {
      setTopicNumber('');
    } else {
      setTopicNumber(topic);
    }
  };

  // レッスンボタン押下時処理
  const onClickTrainingButton = (
    trainingId: number,
    contents: CourseInfo[],
  ) => {
    // トレーニング画面に遷移
    const state: SelectTrainingPageState = {
      trainingId,
      contents,
    };
    history.push({ pathname: PAGE_PATH_NAME.TRAINING, state });
  };

  // 続きからボタン押下時処理
  const onClickContinueButton = (
    trainingId: number,
    contents: CourseInfo[],
  ) => {
    const state: SelectTrainingPageState = {
      trainingId,
      contents,
    };

    history.push({ pathname: PAGE_PATH_NAME.TRAINING, state });
  };

  return {
    topicNumber,
    onClickTopicButton,
    onClickTrainingButton,
    onClickContinueButton,
  };
};
export default useSelectTraining;
